import React from 'react';
import { Link } from 'react-router-dom';
import './HomeIntro.css';

/**
 * Ana sayfanın tanıtım bölümü.
 * Sitenin tek H1'i burada; Hero yalnızca görsel olduğu için ana sayfadaki
 * taranabilir açıklayıcı metin de buradan gelir.
 */
const HomeIntro = () => (
  <section className="home-intro" aria-labelledby="home-intro-title">
    <div className="home-intro-inner">
      <h1 id="home-intro-title" className="home-intro-h1">
        İskoçya Fenerbahçeliler Derneği
      </h1>

      <p className="home-intro-lead">
        İskoçya'da Fenerbahçe sevgisini birlik, dayanışma ve güçlü bir aidiyetle yaşatıyoruz.
      </p>

      <h2 className="home-intro-h2">İskoçya'da Fenerbahçe, Hep Birlikte</h2>

      <div className="home-intro-text">
        <p>
          <strong>İskoçya Fenerbahçeliler Derneği</strong> (<em>Fenerbahçe Scotland</em>), merkezi{' '}
          <strong>Edinburgh</strong>'da bulunan ve İskoçya genelinde faaliyet gösteren resmi bir
          Fenerbahçe taraftar derneğidir. Fenerbahçe'ye gönül verenleri ortak değerler, güçlü bir
          aidiyet ve sarı-lacivert sevda etrafında bir araya getiriyoruz.
        </p>
        <p>
          Maç organizasyonlarından sosyal ve kültürel etkinliklere, toplumsal projelerden üyelerimizi
          bir araya getiren buluşmalara kadar gerçekleştirdiğimiz çalışmalarla Fenerbahçe ruhunu
          İskoçya'da güçlü bir şekilde temsil ediyor ve geleceğe taşıyoruz.
        </p>
        <p>
          <Link to="/dernegimiz">Derneğimizin amacı, vizyonu, faaliyetleri ve yönetim kurulu</Link>{' '}
          hakkında daha fazla bilgi edinebilir; <Link to="/news">güncel haberlerimizi</Link> takip
          edebilir ve çalışmalarımızla ilgili{' '}
          <Link to="/contact">bizimle iletişime geçebilirsiniz</Link>.
        </p>
        <p className="home-intro-closing">
          Sarı-lacivert renklere gönül veren herkesi, İskoçya'daki bu güçlü Fenerbahçe ailesinin bir
          parçası olmaya davet ediyoruz.
        </p>
      </div>

      <div className="home-intro-actions">
        <Link to="/membership" className="home-intro-btn">
          Üyelik Başvurusu
        </Link>
        <Link to="/dernegimiz" className="home-intro-link">
          Derneğimiz <span aria-hidden="true">→</span>
        </Link>
      </div>
    </div>
  </section>
);

export default HomeIntro;
